<template>
  <!-- 表格 -->
  <a-table :columns="columns" :dataSource="dataSource" :loading="searchLoading" :pagination="false" :scroll="{ x: columns.length > 6 ? 1500 : 0, y: tableHeight }" class="table" size="small">
    <template #bodyCell="{ column, record }">
      <template v-if="column.key == 'status_text'">
        <span v-if="record.status == 1" class="f-c-red"> {{ record.status_text }} </span>
        <span v-else class="f-c-green"> {{ record.status_text }} </span>
      </template>
    </template>
  </a-table>

  <!-- 分页 -->
  <MyPagination :pageTotal="pageTotal" class="pagination" @onShowSizeChange="onShowSizeChange" @pageChange="pageChange" />
</template>

<script>
import { onMounted, reactive, toRefs, watch } from 'vue';
import { otaYunZhangGuiRegisterList } from '@/api/api';
import useUtils from '@/hooks/useUtils.js'; //工具库
import store from '@/store/pms/landlord/index'; //VUEX

export default {
  setup() {
    let { countTable, imgCut } = useUtils();

    // 搜索
    const search = reactive({
      topDom: '',
      searchLoading: false,
      searchForm: {
        start: 0,
        limit: store.getters.getPageSize,
      },
      rangePicker: [],
      visiblePopover: false,
    });

    // 表格
    const table = reactive({
      tableHeight: '',
      dataSource: [],
      initColumns: [],
      columns: [
        { title: '记录ID', dataIndex: 'id', key: 'id', align: 'center', width: 100 },
        { title: '账号', dataIndex: 'account_id', key: 'account_id', align: 'center', width: 150, ellipsis: true },
        { title: '密码', dataIndex: 'password', key: 'password', align: 'center', width: 150, ellipsis: true },
        { title: '姓名', dataIndex: 'user_name', key: 'user_name', align: 'center', width: 100, ellipsis: true },
        { title: '门店名称', dataIndex: 'store_name', key: 'store_name', align: 'center', width: 150, ellipsis: true },
        { title: '所在城市', dataIndex: 'city_name', key: 'city_name', align: 'center', width: 100, ellipsis: true },
        { title: '状态', dataIndex: 'status_text', key: 'status_text', align: 'center', width: 80, ellipsis: true },
        { title: '备注', dataIndex: 'msg', key: 'msg', align: 'center', width: 200, ellipsis: true },
        {
          title: '注册时间',
          dataIndex: 'create_time',
          key: 'create_time',
          align: 'center',
          width: 160,
          ellipsis: true,
        },
      ],
      getTableData() {
        search.searchLoading = true;
        otaYunZhangGuiRegisterList({
          hname: search.searchForm.hname,
          mid: search.searchForm.mid ? search.searchForm.mid : '',
          type: search.searchForm.type ? search.searchForm.type : '',
          status: search.searchForm.status ? search.searchForm.status : 0,
          date: search.searchForm.date,
          start: search.searchForm.start,
          limit: search.searchForm.limit,
        })
          .then(res => {
            table.dataSource = res.data.list;
            pagination.pageTotal = res.data.count;
            search.searchLoading = false;
          })
          .catch(() => {
            search.searchLoading = false;
          });
      },
    });

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableData();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableData();
      },
    });

    watch(
      () => store.state.ContentHeight,
      () => {
        table.tableHeight = countTable(search.topDom) - 10;
      }
    );

    onMounted(() => {
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 10;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(pagination),
      imgCut,
    };
  },
};
</script>

<style lang="scss" scoped>
.ant-tabs > .ant-tabs-nav {
  margin: 0 !important;
}

.fRed {
  color: red;
}

.bar {
  border-radius: 10px;
  padding: 2px 10px;
  height: 20px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
}

.add-box {
  width: 100%;
  display: flex;
  // justify-content: space-between;
  padding: 0 10px;

  .add-lef {
    flex: 1;
    margin-right: 40px;
  }

  .add-rig {
    flex: 1;
  }
}

.checkbox {
  margin-left: 90px;
  margin-bottom: 24px;
}

.rowClick {
  cursor: pointer;
}
</style>
